import ApiRequest from '../../../Apis/request'

export default class ApiVotes {
  constructor() {
    this.apiRequest = new ApiRequest()
  }

  async postAgResolutionVotesAllAgainst(agId, resolutionId) {
    const res = await this.apiRequest.post(
      `v2/backoffice/general-assemblies/${agId}/resolutions/${resolutionId}/votes/all-against`
    )
    return res
  }
}
